module.exports = __webpack_public_path__ + "static/home-product1-eda1b1b3efedcf1f66413c8d7a9a7ff4.png";